import React from 'react';
import { Input, Button, PaperClip, TitleModalRight } from 'components';
import { CategoryService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';

interface Props {
	onClose?: any;
	item?: any;
	title?: string;
}

class ModalCreateCategory extends React.Component<Props> {

	state = {
		form: {
			name: ''
		}
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name || ''
				}
			});
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await CategoryService.admin.update({
				category_id: this.props.item?.id,
				...this.state.form
			});
			Globals.showSuccess("Se ha modificado la categoría correctamente");
			this.props.onClose();
		}
		else {
			await CategoryService.admin.create({
				...this.state.form
			});
			Globals.showSuccess("Se ha creado la categoría correctamente");
			this.props.onClose();
		}
	}
	
	render() {
		return (
			<div id="modal-create-categories">
				<TitleModalRight
					title={ this.props.title }
					onClose={ this.props.onClose }
				/>
				<form className="container-scroll-modal-right" onSubmit={ this.submit }>
					<div className="col-md-12">
						<Input
							color="white"
							value={ this.state.form.name }
							name="name" 
							placeholder="Nombre"
							onChange={ this.change } />
					</div>
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreateCategory;